import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import useUser from 'src/hooks/use-user';

import { ModalWrapper } from 'shared/modals/v2-wrapper';

import { ModalContainer, BottomDrawer, ModalExitIcon } from 'src/components/core';
import { withModalControlsHook, ModalComponentProps } from 'src/components/modals/with-modal-controls-hook';
import { CompleteAccount } from './complete-account';

const CompleteAccountModal = ({ onClose: closeModal, containerProps }: ModalComponentProps): JSX.Element => {
  const User = useUser();
  const theme = useTheme();
  // noSsr is safe: this modal only mounts client-side, on user action.
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'), { noSsr: true });

  const logoutAndClose = (): void => {
    User.logout();
    closeModal();
  };

  if (isMobile) {
    return (
      <BottomDrawer
        open
        onClose={logoutAndClose}
        shouldCalculateIframeBottom
        data-testid='complete-account-modal'
        {...containerProps}
      >
        <CompleteAccount close={closeModal} />
      </BottomDrawer>
    );
  }

  return (
    <ModalWrapper open>
      <ModalContainer width='470px' p='32px' textAlign='left' data-testid='complete-account-modal' {...containerProps}>
        <ModalExitIcon onClick={logoutAndClose} />
        <CompleteAccount close={closeModal} />
      </ModalContainer>
    </ModalWrapper>
  );
};

const [CompleteAccountController, useCompleteAccountModal] = withModalControlsHook(CompleteAccountModal);

export { useCompleteAccountModal, CompleteAccountController };
